import styled from 'styled-components';
import { colors } from '../colors';

interface labelProps {
	margin?: string;
	padding?: string;
	marginTop?: string;
	marginBottom?: string;
	marginLeft?: string;
	marginRight?: string;
	fontSize?: string;
	float?: string;
	width?: string;
	textAlign?: string;
	lineHeight?: string;
	display?: string;
	h1?: boolean;
	h2?: boolean;
	h3?: boolean;
	h4?: boolean;
	h5?: boolean;
	h6?: boolean;
	normal?: boolean;
	semiBold?: boolean;
	Bold?: boolean;
	black?: boolean;
}
const Label = styled.label<labelProps>`
	margin: 0px;
	white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;
	margin: ${({ margin }) => margin};
	padding: ${({ padding }) => padding};
	margin-top: ${({ marginTop }) => marginTop}!important;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	margin-left: ${({ marginLeft }) => marginLeft}!important;
	margin-right: ${({ marginRight }) => marginRight}!important;
	font-size: ${({ fontSize }) => fontSize}!important;
	float: ${({ float }) => float}!important;
	width: ${({ width }) => width}!important;
	text-align: ${({ textAlign }) => textAlign}!important;
	line-height: ${({ lineHeight }) => lineHeight}!important;
	display: ${({ display }) => display}!important;
	cursor: auto;
	${({ black }) =>
		black &&
		`color: ${colors.Black};
	`}
	${({ normal }) =>
		normal &&
		`font-family: 'RubikRegular'!important;
	`}
	${({ semiBold }) =>
		semiBold &&
		`font-family: 'RubikMedium'!important;
	`}
	${({ Bold }) =>
		Bold &&
		`font-family: 'RubikBold'!important;
	`}
	${({ h1 }) =>
		h1 &&
		`font-size: 26px;
	`}
	${({ h2 }) =>
		h2 &&
		`font-size: 22px;
	`}
	${({ h3 }) =>
		h3 &&
		`font-size: 18px;
	`}
	${({ h4 }) =>
		h4 &&
		`font-size: 16px;
	`}
	${({ h5 }) =>
		h5 &&
		`font-size: 14px;
		Line Height: 17px
	`}
	${({ h6 }) =>
		h6 &&
		`font-size: 12px;
		Line Height: 19px
	`}
`;

export default Label;
